// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SafetyAnchorPointListModel from '../../model/safety-anchor-point-list-model';
import SafetyAnchorPointListDTO from '../dto/safety-anchor-point-list-dto';
import dtoSchema from '../schemas/safety-anchor-point-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import DocumentModel from '../../model/document-model';

export default abstract class SafetyAnchorPointListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SafetyAnchorPointListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.name = data.name ?? undefined;
      this.remark = data.remark ?? undefined;
      this.position = data.position ?? undefined;
      this.safetyHookId = data.safetyHookId;
      this.screwLength = data.screwLength ?? undefined;
      this.isInstalledOnCounterBatten = data.isInstalledOnCounterBatten;
      this.documentList = data.documentList?.map((i) => DocumentModel.toModel(i)) ?? [];
      this.installationRemark = data.installationRemark ?? undefined;
      this.installationDate = data.installationDate;
      this.isDocumentationCompleted = data.isDocumentationCompleted;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  name?: string;
  /**
  */
  remark?: string;
  /**
  */
  position?: string;
  /**
  * @type {int64}
  */
  safetyHookId?: number;
  /**
  */
  screwLength?: string;
  /**
  */
  isInstalledOnCounterBatten?: boolean;
  /**
  */
  documentList?: DocumentModel[];
  /**
  */
  installationRemark?: string;
  /**
  * @type {date-time}
  */
  installationDate?: string;
  /**
  */
  isDocumentationCompleted?: boolean;

  static toModel(dto: DeepPartial<SafetyAnchorPointListDTO>): SafetyAnchorPointListModel;
  static toModel(dto: DeepPartial<SafetyAnchorPointListDTO> | undefined | null): SafetyAnchorPointListModel | undefined;
  static toModel(dto: DeepPartial<SafetyAnchorPointListDTO> | undefined | null): SafetyAnchorPointListModel | undefined {
    return dto ? new SafetyAnchorPointListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SafetyAnchorPointListModel> | SafetyAnchorPointListModel): SafetyAnchorPointListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      name: unwrapped.name,
      remark: unwrapped.remark,
      position: unwrapped.position,
      safetyHookId: unwrapped.safetyHookId,
      screwLength: unwrapped.screwLength,
      isInstalledOnCounterBatten: unwrapped.isInstalledOnCounterBatten,
      documentList: unwrapped.documentList,
      installationRemark: unwrapped.installationRemark,
      installationDate: unwrapped.installationDate,
      isDocumentationCompleted: unwrapped.isDocumentationCompleted,
    } as SafetyAnchorPointListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SafetyAnchorPointListModel, can not map to SafetyAnchorPointListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
